module.exports = __webpack_public_path__ + "img/p5.73760131.png";